import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Users, Trophy, Calendar, Coffee, Wrench, DollarSign } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ComitePage = () => {
  const comiteMembers = [
    {
      name: "Volery Nicolas",
      role: "Padel, logistique et Coach J+S",
      color: "from-blue-500 to-cyan-600",
      icon: Users
    },
    {
      name: "Kaenel Stephan",
      role: "Caissier",
      color: "from-purple-500 to-pink-600",
      icon: DollarSign
    },
    {
      name: "Tissot Lucile",
      role: "Secrétaire et Juniors",
      color: "from-orange-500 to-red-600",
      icon: Calendar
    },
    {
      name: "Bataillé Xavier",
      role: "Buvette",
      color: "from-indigo-500 to-blue-600",
      icon: Coffee
    },
    {
      name: "Moyano Oscar",
      role: "Infrastructures",
      color: "from-teal-500 to-cyan-600",
      icon: Wrench
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header scrollY={100} />
      
      <div className="pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>
          
          <div className="mb-12">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Comité et entraîneurs
            </h1>
            <p className="text-xl text-gray-600">
              Les personnes qui font vivre le club
            </p>
          </div>

          {/* Le Comité */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">Le comité actuel</h2>
            <p className="text-xl text-gray-600 mb-8">Le comité est composé de 5 personnes</p>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {comiteMembers.map((member, index) => {
                const Icon = member.icon;
                return (
                  <div
                    key={index}
                    className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all hover:scale-105"
                  >
                    <div className={`h-2 bg-gradient-to-r ${member.color}`}></div>
                    <div className="p-6">
                      <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${member.color} flex items-center justify-center mb-4`}>
                        <Icon className="w-7 h-7 text-white" />
                      </div>
                      
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">
                        {member.name.split(' ')[0]}
                      </h3>
                      <h3 className="text-2xl font-bold text-gray-900 mb-3">
                        {member.name.split(' ')[1]}
                      </h3>
                      
                      <p className="text-gray-600 mb-4 font-semibold">
                        {member.role}
                      </p>
                      
                      <a 
                        href="mailto:tccheyres@gmail.com"
                        className="inline-flex items-center text-green-600 hover:text-green-700 text-sm transition-colors"
                      >
                        <Mail className="w-4 h-4 mr-2" />
                        tccheyres@gmail.com
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Nos Entraîneurs */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-10 rounded-3xl">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Nos entraîneurs</h2>
            
            <p className="text-xl text-gray-700 leading-relaxed mb-8">
              Au TC Cheyres-Châbles nous avons la chance d'avoir deux excellents entraîneurs, 
              de la fondation STM club.
            </p>
            
            <div className="bg-white rounded-2xl shadow-lg p-8 mb-6">
              <div className="flex items-center mb-4">
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center mr-4">
                  <Users className="w-8 h-8 text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">Kaël Piguet et Kilian Zurita</h3>
                  <p className="text-gray-600 font-semibold">Entraîneurs</p>
                </div>
              </div>
              
              <a 
                href="https://www.stmclubs.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-green-600 hover:text-green-700 font-semibold mt-4"
              >
                🔗 Leur site : https://www.stmclubs.com
              </a>
            </div>

            <div className="text-sm text-gray-600">
              <p>
                <strong>STM Club</strong> est fondé par Fabrice Sbarro, coach international sur le circuit 
                ATP/WTA/ITF et Patrick Thomet, ancien joueur R1 et entraîneur Swisstennis A.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ComitePage;
